import { BaseService } from 'core/services';
import UnitOfMeasureRouteService from './UnitOfMeasureRouteService';

class UnitOfMeasureService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new UnitOfMeasureRouteService());
    }
}

export default UnitOfMeasureService;
